import PlusCareLogoImage from "../assets/images/logo.png";

export default function PlusCareLogo() {
    return <img src={PlusCareLogoImage} alt="Plus-care" />;
}
